export const BottomBarReducer = (state = "", action) => {
  switch (action.type) {
    case "CLICKED":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
